module.exports = __webpack_public_path__ + "static/img/linglongfangong.7da2977.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/linglongfangong.png
// module id = C7Wh
// module chunks = 1